var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEvaluating = function SvgEvaluating(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.705 32.001c-.94 0-1.705-.766-1.705-1.705V1.706C0 .766.766.001 1.705.001c.94 0 1.706.766 1.706 1.705v26.877h30.524c.94 0 1.706.766 1.706 1.706s-.766 1.705-1.706 1.705H1.705v.007Z",
    fill: "#1C7CE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.411 26.92c-.264 0-.522-.056-.766-.174a1.784 1.784 0 0 1-.918-1.016c-.16-.453-.133-.94.07-1.372l3.96-10.086a1.812 1.812 0 0 1 1.859-1.01l5.54.745 6.05-8.262a1.794 1.794 0 0 1 2.415-.446l6.83 4.386V7.728a1.74 1.74 0 0 1 3.48 0v5.945c0 .96-.78 1.74-1.74 1.74h-5.82a1.74 1.74 0 0 1 0-3.48h.947l-4.212-2.7-5.687 7.76a1.794 1.794 0 0 1-1.685.718l-5.304-.717-3.397 8.903c-.3.62-.933 1.023-1.622 1.023Z",
    fill: "#1C7CE5"
  })));
};
export default SvgEvaluating;